import React, { FunctionComponent, useEffect } from 'react'

import { useTheme } from 'styled-components/native'

import { Appointment } from '@lyrahealth-inc/shared-app-logic/src/models/appointment/Appointment'

import { InformedConsentBannerProps, ZoomVideoSessionDesktop } from './ZoomVideoSessionDesktop'
import { ZoomVideoSessionMobile } from './ZoomVideoSessionMobile'
import { AvatarDetails } from '../../atoms/icons/Avatar'
import { AddToastFunction, JoinSessionParams, RecordingFetchMode, RecordSessionProps } from '../../hooks/useZoom/types'
import { useZoom } from '../../hooks/useZoom/useZoom'
import { ThemeType } from '../../utils/themes/ThemeProvider'
import { FullScreenOverlay } from '../fullScreenOverlay/FullScreenOverlay'

export type ZoomVideoSessionProps = {
  getSessionParams: () => Promise<JoinSessionParams>
  appointment: Appointment
  participantName: string
  participantFirstName?: string
  avatarDetails?: AvatarDetails
  participantTitle?: string
  onSessionOpened?: () => void
  onSessionStarted?: () => void
  onSessionEnded?: () => void
  onSessionClosed?: () => void
  isRecording?: boolean
  messenger?: React.ReactElement
  onOpenMessagesPressed?: () => void
  unreadMessageCount?: number
  addToast?: AddToastFunction
  onDisableRecordingPressed?: () => void
  disableMobileView?: boolean
  showRecordingConsentBanner?: boolean
  recordSessionProps?: RecordSessionProps
  hideSessionNumber?: boolean
  hideRecordingWarning?: boolean
  hideNotRecordingBadge?: boolean
  informedConsentBanner?: InformedConsentBannerProps
  onInformedConsentBannerHeightChange?: (height: number) => void
}

export const ZoomVideoSession: FunctionComponent<ZoomVideoSessionProps> = (props) => {
  const theme = useTheme() as ThemeType
  const { setIsRecording, config } = useZoom()
  useEffect(() => {
    if (props.isRecording !== undefined && config.recordingFetchMode === RecordingFetchMode.PROVIDER) {
      setIsRecording(props.isRecording)
    }
  }, [props.isRecording, setIsRecording, config.recordingFetchMode])
  if (!props.disableMobileView && theme.breakpoints.isMobileSized) {
    return (
      <FullScreenOverlay isOpen isFocused={false}>
        <ZoomVideoSessionMobile {...props} />
      </FullScreenOverlay>
    )
  }
  return <ZoomVideoSessionDesktop {...props} />
}
